function setCookie(cname, cvalue, exdays = 0) {
  var date, expires;
  if (exdays) {
    date = new Date();
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
    expires = ' expires=' + date.toGMTString();
  }
  document.cookie = cname + '=' + cvalue + '; path=/;' + expires;
}

function hasCookieVal(cname, val) {
  if (document.cookie.indexOf(cname + '=' + val) >= 0) {
    return true;
  }
  return false;
}

function hasCookie(cname) {
  if (hasCookieVal(cname, 'true')) {
    return true;
  }
  return false;
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function hasCookieSplitVal(cname, val) {
  var value = getCookie(cname);
  var split = value.split('|');
  for (var i = 0; i < split.length; i++) {
    var c = split[i];
    if (c.indexOf(val) == 0) {
      return true;
    }
  }
  return false;
}

function addCookieSplitVal(cname, val, exdays = 0) {
  var newval;
  var value = getCookie(cname);
  if (value) {
    var split = value.split('|');
    for (var i = 0; i < split.length; i++) {
      var c = split[i];
      if (c == val) {
        return false;
      }
    }
    split.push(val);
    newval = split.join('|');
  } else {
    newval = val;
  }
  setCookie(cname, newval, exdays);
}

function removeCookieSplitVal(cname, val, exdays = 0) {
  var value = getCookie(cname);
  var split = value.split('|');
  var filtered = split.filter(function(value, index, arr) {
    return value != val;
  });
  var newval = filtered.join('|');
  setCookie(cname, newval, exdays);
}

function removeCookie(cname) {
  document.cookie = cname + '= ;  path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT';
}

var header = $('#header');
var hero = $('.hero');
var menu = $('#main-menu');

/* Google Fonts laden */
var WebFontConfig = {
  google: {
    families: ['Roboto:300', 'Roboto+Condensed']
  }
};
(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

$('.no-js').removeClass('no-js').addClass('js');

$('.menu-button').click(function(e) {
  menu.slideToggle();
  setMenuHeight();
});

// Softscroll
$('.a_link').mouseup(function() {
  this.blur();
})

$('a[href^="#"]').on('click', function(e) {
  var href = $(this).attr('href');
  if ($(href).offset()) {
    $('html, body').animate({
      scrollTop: $(href).offset().top - 200
    }, 'slow');
  }

  e.preventDefault();
});


// Untermenü
$('.menu-children').children('a').click(function(e) {
  e.preventDefault();

  var parent = $(this).parent();

  if (parent.hasClass('open')) {
    parent.removeClass('open').children('ul').slideUp('fast');
  } else {

    var open = $('.open');

    if (open.length > 0) {
      $('.open').removeClass('open').children('ul').slideUp('fast', function() {
        parent.addClass('open').children('ul').slideDown('fast');
      });
    } else {
      parent.addClass('open').children('ul').slideDown('fast');
    }

  }

});

$(document).click(function(e) {
  var menu = $(".menu-children.open");
  if ($(window).width() >= 768 && !menu.is(e.target) && menu.has(e.target).length === 0) {
    $('.menu-children.open').removeClass('open').children('ul').slideUp('fast');
  }
});

// Header Fixieren
$(window).scroll(function() {
  var scroll = getCurrentScroll();
  if (scroll >= 200) {
    header.addClass('smaller');
  } else {
    header.removeClass('smaller');
  }
}).scroll();

window.onload = function() {
  $(window).resize(function() {
    window.setTimeout(fixHeader(), 500)
  }).resize();
};


function fixHeader() {
  var isSmaller = header.hasClass('smaller');
  if (isSmaller) {
    header.removeClass('smaller').addClass('no-transition');
  }
  hero.css('margin-top', header.outerHeight() + 'px');
  header.addClass('fixed');
  setMenuHeight();
  if (isSmaller) {
    header.addClass('smaller');
    setTimeout(function() {
      header.removeClass('no-transition');
    }, 250);
  }

}

function setMenuHeight() {

  menu.css({
    'top': header.outerHeight() + 'px',
    'max-height': $(window).height() - header.outerHeight() + 'px'
  });

}

function getCurrentScroll() {
  return window.pageYOffset || document.documentElement.scrollTop;
}

$('.disrupter_link').click(function(e) {
  e.preventDefault();
	setCookie('disrupter_closed', 'true', 30);
  window.location.href = $(this).attr('href');
});

$('#disrupter_close').click(function() {
    $('#disrupter').hide();
    setCookie('disrupter_closed', 'true', 30);
  });

$(document).ready(function() {
  if (!hasCookie('disrupter_closed')) {
    $('#disrupter').show();
  }
});
